import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import Images from "../assets/Image";
import emailjs from "@emailjs/browser";
export default function ContactUsFooter() {
  const {
    formState: { errors },
    register,
  } = useForm();

  const [isOpen, setIsOpen] = useState(false);
  const form = useRef();
  const [showIcons, setShowIcons] = useState(false);
  useEffect(() => {
    // For the address block
    const addressElements = document.querySelectorAll(
      ".contactEnquiryAddressBlock",
    );
    const addressObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible-address");
          }
        });
      },
      {
        threshold: 0.1,
      },
    );
    addressElements.forEach((el) => addressObserver.observe(el));

    // For the form fields
    const inputFields = document.querySelectorAll(".enquiryFormInputField");
    const formObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add("visible-form");
            }, index * 300); // stagger the animation for each field
          }
        });
      },
      {
        threshold: 0.1,
      },
    );
    inputFields.forEach((input) => formObserver.observe(input));

    return () => {
      addressObserver.disconnect();
      formObserver.disconnect();
    };
  }, []);
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_520oyz9", "template_xr5ts3y", form.current, {
        publicKey: "YI1Dlv7k1QHWv_o9e",
      })
      .then(
        () => {
          console.log("SUCCESS!");
          alert("form submitted successfully..");
        },
        (error) => {
          console.log("FAILED...", error.text);
        },
      );
  };
  return (
    <div>
      <div className="contactUs_Main_Section">
        <div className="contactusEnquirySection">
          <div className="contactUsEnquiryAddressBlock">
            <h6 className="enquiry_address_heading">Contact us</h6>
            <p className="--contact-address my-3">
              Have a question or interested in learning more about us and our
              products? Please contact us using the "Get in Touch" form below or
              by emailing <u style={{ color: "#3185D2" }}>enquiries@usppkg.com</u>
              / by calling  <u style={{ color: "#3185D2" }}>+91 9790934910</u>.
            </p>
            <div className="contactEnquiryAddressBlock">
              <div className="enquiry_card_img_block">
                <div className="enquiry_card-image">
                  <img
                    src={Images?.locationIcon}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
              </div>

              <p className="--contact-address">
                Old No. 15/1, New No. 37, Dr.Muthulakshmi Salai,
                <br /> Lattice Bridge Road, Adyar, Chennai 600020, India.
              </p>
            </div>
            <div className="contactEnquiryAddressBlock">
              <div className="enquiry_card_img_block">
                <div className="enquiry_card-image">
                  <img
                    src={Images?.phoneCall}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
              </div>
              <p className="--contact-address">+91 9790934910</p>
            </div>
            <div className="contactEnquiryAddressBlock">
              <div className="enquiry_card_img_block">
                <div className="enquiry_card-image">
                  <img
                    src={Images?.meaageIcon}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
              </div>
              <p className="--contact-address">enquiries@usppkg.com</p>
            </div>
            <div className="contactEnquiryAddressBlock">
              <div className="enquiry_card_img_block">
                <div className="enquiry_card-image">
                  <img
                    src={Images?.clockIcon}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
              </div>
              <p className="--contact-address">
                Mon-Fri 9.30 am to 6.00 pm
                <br />
                Sat 9.30 am to 1.00 pm
              </p>
            </div>
          </div>
          <div className="contactUsEnquiryFormBlock">
            <h5 className="contactUsEnquiryFormHeading">Get In Touch</h5>
            <form ref={form} onSubmit={sendEmail}>
              <div>
                <input
                  type="text"
                  name="from_name"
                  className="enquiryFormInputField"
                  placeholder="Name"
                  required
                />
              </div>
              <div>
                <input
                  type="email"
                  name="from_email"
                  className="enquiryFormInputField"
                  placeholder="Email Id"
                  required
                />
              </div>
              <div>
                <input
                  type="tel"
                  name="mobileNumber"
                  className="enquiryFormInputField"
                  placeholder="Mobile Number"
                  required
                />
              </div>
              <div>
                <input
                  type="text"
                  name="need"
                  className="enquiryFormInputField"
                  placeholder="Need"
                  required
                />
              </div>
              <div>
                <input
                  type="text"
                  name="message"
                  className="enquiryFormInputField"
                  placeholder="What is your need"
                  required
                />
              </div>
              <div className="contactus_btn_block">
                <button className="contactUsSubmitBtn">Submit Now</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
}
